/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/create_accessibility_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCreateAccessibilityTestCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdCreateAccessibilityTestProps, CreateAccessibilityTestResult } from "./types";

export const postCreateAccessibilityTest = reactQueryMutationAdapter(
  engagementAppGroupIdCreateAccessibilityTestCacheKeys,
  ({
    appGroupId,
    message,
    triggerPropertiesHash,
  }: PostEngagementAppGroupIdCreateAccessibilityTestProps): Promise<CreateAccessibilityTestResult> => {
    return fetch(
      `/engagement/${appGroupId}/create_accessibility_test`,
      "POST",
      {
        message,
        trigger_properties_hash: triggerPropertiesHash,
      },
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
